import React, { Component } from "react";

export default class About extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-about" data-section="about">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div className="col-md-12">
                <div
                  className="row row-bottom-padded-sm animate-box"
                  data-animate-effect="fadeInLeft"
                >
                  <div className="col-md-12">
                    <div className="about-desc">
                      <span className="heading-meta">About Me</span>
                      <h2 className="colorlib-heading">Who Am I?</h2>
                      <p>
                        Software Engineer with experience and a proven knowledge
                        of web platform development, programming and project
                        lifecycle. Aiming to leverage my skills and quick to
                        pick up new ones. Always looking for new challenges and
                        overcome them surrounded by trust and teamwork.
                      </p>
                      <p>
                        Ever since I got my professional degree, I have been
                        constantly looking how to improve my skills and overcome
                        my weaknesses and interact in a better way with
                        coworkers around the world like Spain, Netherlands,
                        Israel, India and United States mainly. My professional
                        experience is in Software development, currently I am
                        working from Spain in a 100% remote position. I am
                        open-minded, language-agnostic and focused on new
                        developments in my field. I have proven to be effective
                        and motivational, with proficiency in collaboration and
                        collaborative work. I enjoy brainstorming and
                        coordinating efforts to achieve a common goal.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="colorlib-about">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div
                className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box"
                data-animate-effect="fadeInLeft"
              >
                <span className="heading-meta">What I do?</span>
                <h2 className="colorlib-heading">My expertise</h2>
              </div>
            </div>
            <div className="row row-pt-md">
              <div className="col-md-4 text-center animate-box">
                <div className="services color-1">
                  <span className="icon">
                    <i className="icon-phone3" />
                  </span>
                  <div className="desc">
                    <h3>Front-End Development </h3>
                    <p>
                      I have experience building websites using React,
                      Typescript, Tailwind and integrating third party APIs.{" "}
                      <br></br>
                      <br></br>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 text-center animate-box">
                <div className="services color-3">
                  <span className="icon">
                    <i className="icon-bulb" />
                  </span>
                  <div className="desc">
                    <h3>Back-End Development</h3>
                    <p>
                      I started my professional career building applications in
                      C#, ASPX, Crystal Reports, SQL. Recently I have built
                      RESTful APIs using Node.js and MongoDB and PHP.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 text-center animate-box">
                <div className="services color-5">
                  <span className="icon">
                    <i className="icon-layers2" />
                  </span>
                  <div className="desc">
                    <h3>Dev Ops</h3>
                    <p>
                      I have reduced the development time of a website from 2
                      weeks to 30 minutes using Powershell.
                      <br></br>
                      <br></br>
                    </p>
                  </div>
                </div>
              </div>
              {/*
            <div className="col-md-4 text-center animate-box">
                <div className="services color-2">
                <span className="icon">
                    <i className="icon-data" />
                </span>
                <div className="desc">
                    <h3>Dev Ops</h3>
                    <p>Jenkins , Kubernetes , Docker </p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-4">
                <span className="icon">
                    <i className="icon-layers2" />
                </span>
                <div className="desc">
                    <h3>Graphic Design</h3>
                    <p>My friend knows .. P</p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-6">
                <span className="icon">
                    <i className="icon-phone3" />
                </span>
                <div className="desc">
                    <h3>Digital Marketing</h3>
                    <p>I use Instagram eight hours a day :) </p>
                </div>
                </div>
            </div>
            */}
            </div>
          </div>
        </section>
      </div>
    );
  }
}
